/**
 * Componente de visualización de estrellas de racha
 * 1 estrella = 1 día de racha, máximo 5 estrellas
 */

import { useEffect, useState } from 'react';
import './StarRating.css';

interface StarRatingProps {
  streak: number; // Días de racha (1-5)
  animated?: boolean; // Si debe animarse al cambiar
}

export function StarRating({ streak, animated = true }: StarRatingProps) {
  const [displayStreak, setDisplayStreak] = useState(streak); // Inicializar con el valor actual

  useEffect(() => {
    if (animated) {
      // Animación suave al cambiar la racha
      const timer = setTimeout(() => {
        setDisplayStreak(streak);
      }, 100);
      return () => clearTimeout(timer);
    } else {
      setDisplayStreak(streak);
    }
  }, [streak, animated]);

  const starCount = Math.min(displayStreak, 5);
  const emptyCount = 5 - starCount;

  return (
    <div className="star-rating">
      {Array.from({ length: starCount }).map((_, index) => (
        <span
          key={`filled-${index}`}
          className="star star-filled"
          style={{ animationDelay: `${index * 0.1}s` }}
        >
          ⭐
        </span>
      ))}
      {Array.from({ length: emptyCount }).map((_, index) => (
        <span key={`empty-${index}`} className="star star-empty">
          ☆
        </span>
      ))}
    </div>
  );
}

